import contractor_history_actions from "./contractor_history/action_types.js";
import modal_connect_with_actions from "./modal_connect_with/action_types.js";
import modal_generate_balance_actions from "./modal_generate_balance/action_types.js";
import payments_actions from "./payments/action_types.js";
import alerts_actions from "./alerts/action_types.js";
import payments from "./payments/action_types.js";
import price_list from "./price_list/action_types.js";
import generate_transfer_list from './generate_transfer_list/action_types.js';
import contract_form from './contract-form/action_types.js';

export default Object.assign(
    {
        FETCH_TRANSLATIONS: "fetchTranslations",
        FETCH_USER_INFO: "fetchUserInfo",
        FETCH_SELECT2_CONTRACTORS_LIST: "fetchContractorsListForSelect",
        FETCH_SERVER_INFO: "fetchServerInfo",
        FETCH_SELECT2_CURRENCIES_LIST: "fetchCurrenciesListForSelect",
        FETCH_SELECT2_DOCUMENTS_CURRENCIES_LIST:
            "fetchDocumentsCurrenciesListForSelect",
        SAVE_COUNTRIES_TRANSLATIONS: "saveCountriesTranslations"
    },
    contractor_history_actions,
    modal_connect_with_actions,
    modal_generate_balance_actions,
    payments_actions,
    alerts_actions,
    payments,
    price_list,
    generate_transfer_list,
    contract_form
);
